"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./OverflowSet"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/OverflowSet/index.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/OverflowSet/index.js
// module chunks = 1